<template>
  <div class="spe">
    <div class="select-area">
      <div class="box" style="margin-left: 0px;">
          <div class="line" v-if="selecting === 0"></div> 
          <span class="title" :class="{cur: selecting === 0}" @click="changeSelect(0)">
              创建的面试
              <!-- <span  v-if="selecting === 0">（{{total}}）</span> -->
          </span>
      </div>
      <div class="box">
        <div class="line" v-if="selecting === 3"></div> 
        <span class="title" :class="{cur: selecting === 3}" @click="changeSelect(3)">
            参与的面试
            <!-- <span  v-if="selecting === 3">（{{total}}）</span> -->
        </span>
        </div>
        <div class="box" v-if="company && isSuperAdmin">
            <div class="line" v-if="selecting === 2"></div> 
            <span class="title" :class="{cur: selecting === 2}" @click="changeSelect(2)">
                公司全部面试
                <!-- <span  v-if="selecting === 2">（{{total}}）</span> -->
            </span>
        </div>
        <div class="box">
            <div class="line" v-if="selecting === 4"></div> 
            <span class="title" :class="{cur: selecting === 4}" @click="changeSelect(4)">
                排队面试
                <!-- <span  v-if="selecting === 4">（{{total}}）</span> -->
            </span>
        </div>
        <div class="box" v-if="isAdmin"> 
            <div class="line" v-if="selecting === 8"></div> 
            <span class="title" :class="{cur: selecting === 8}" @click="changeSelect(8)">
                群面
            </span>
        </div>
        <div class="box" v-if="isAdmin"> 
            <div class="line" v-if="selecting === 5"></div> 
            <span class="title" :class="{cur: selecting === 5}" @click="changeSelect(5)">
                空中宣讲
                <!-- <span  v-if="selecting === 5">（{{total}}）</span> -->
            </span>
        </div>
        <div class="box" v-if="company && isAdmin && fromSource === 'aihome'"> 
            <div class="line" v-if="selecting === 6"></div> 
            <span class="title" :class="{cur: selecting === 6}" @click="changeSelect(6)">
                AI视频面试
            </span>
        </div>
        <!-- <div class="box" v-if="isAdmin && company.id !== '833'"> 
            <div class="line" v-if="selecting === 7"></div> 
            <span class="title" :class="{cur: selecting === 7}" @click="changeSelect(7)">
                在线笔试
            </span>
        </div> -->
    </div>
    <!-- <el-divider></el-divider> -->
  </div>
</template>
<script>
import { mapState } from "vuex"
import config from "@/util/config"
export default {
  props: {
    selecting: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    },
  },
  data(){
    return{
      fromSource: '',
    }
  },
  computed: {
    ...mapState(['company','userInfo']),
    isAdmin(){
      return this.company && this.company.role == '2' || this.company && this.company.role == '1'
    },
    isSuperAdmin(){
      return this.company && this.company.role == '1' 
    }
  },
  mounted() {
    this.fromSource = this.$route.query.fr
  },
  methods: {
    changeSelect(number){
      if (number == '7') {
        window.open(config.viBakHost + '/exam/paper?back=7', '_blank')
      } else {
        this.$emit("change-select", number)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.spe{
  width: 100%;
}
.spe >>> .el-divider--horizontal{
  width: calc(100% + 100px);
  margin-top: 5px;
  margin-bottom: 20px;
  box-shadow: 0px 0px 1px 0px rgba(0,0,0,0.1);
  margin-left: -50px;
  z-index: -999;
}
.select-area{
  display: flex;
  align-items: center;
  width: 100%;
  .box{
      display: flex;
      align-items: center;
      margin: 0 10px;
      position: relative;
      .line{
          height: 2px;
          width: 100%;
          background: #5272FF;
          margin-right: 10px;
          position: absolute;
          bottom: -6px;
          display: none;
      }
      .title{
          color: #8B8F94;
          font-size: 16px;
          font-weight: 400;
          cursor: pointer;
          &:hover {
              color: #5272ff;
          }
          &.cur{
              color: #07090c;
              font-weight: 500;
          }
      }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/SelectArea.vue